import React from "react";
import { Navigate, useParams } from "react-router-dom";

// Client (launch toast review): for the older screens, "Reachable with a current
// equivalent: reroute it to the current screen." These keep the old addresses
// working but send them to today's screens instead of the pre-revamp ones.

// /contest/:slug/edit — the classic Create / Edit League form. The organiser's
// current screen for the same league is its Settings.
export const LegacyEditLeagueRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/contest/${slug}/settings`} replace />;
};

// /buysell/:stockname and /:slug/buysell/:ticker — the classic Buy / Sell ticket.
// The current ticket is the Trade screen (/charts on the main account,
// /:slug/trade in a league), which reads the symbol from localStorage "ticker",
// the same key the classic ticket set from its URL.
//
// A NUMERIC segment is not a symbol but an order id: the older Portfolio page's
// "edit order" link. Client: "Yes, reroute to the current league Portfolio,
// where open orders can be edited or canceled." So order ids open the current
// Portfolio instead (`portfolio`).
export const LegacyBuySellRedirect = ({ to, portfolio }) => {
  const params = useParams();
  const segment = params.ticker ?? params.stockname ?? params.id;
  const withSlug = (path) => (params.slug ? `/${params.slug}${path}` : path);

  if (segment && !isNaN(segment)) {
    const target = params.slug ? `/contest/${params.slug}/portfolio` : portfolio;
    return <Navigate to={target} replace />;
  }

  if (segment) {
    try {
      localStorage.setItem("ticker", segment);
    } catch (e) {
      // Storage blocked: the Trade screen falls back to its default symbol.
    }
  }

  return <Navigate to={withSlug(to)} replace />;
};

// /:slug/portfolio — the older league Portfolio page, still opened by the older
// league sidebar. Client: "reroute to the current league Portfolio, where open
// orders can be edited or canceled."
export const LegacyLeaguePortfolioRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/contest/${slug}/portfolio`} replace />;
};
